import pkg from "#basepath/package.json";
import { APP_CONFIG_IP } from "#config/platino-inmobiliaria/constants/app-config.constant";
import { COMPANY_CONFIG_IP } from "#config/platino-inmobiliaria/constants/company-config.constant";
import { Environment } from "#root/config/interfaces/environment.interface";

export const environment: Environment = {
  version: pkg.version,
  hmr: false,
  production: true,
  baseUrl: "https://crm-ip.azurewebsites.net/api/v1/",
  googleMapsKey: "AIzaSyDechfrh9791fuTOLLmzp1_BsB4s6Rd5LE",
  sentryDSN:
    "https://a61166c8bcae490bada845a8faca3ecc@o4505172191608832.ingest.sentry.io/4505211440922624",
  googleAnalyticsId: "G-L3MGDSM9ET",
  googleClientId:
    "280882478275-740o35ja86skqlnl91dgrr3t481pqr84.apps.googleusercontent.com",
  appTitle: (title: string) =>
    `${title ? `${title} | ` : ""}${APP_CONFIG_IP.appName} - Panel Administrativo`,

  appConfig: {
    ...APP_CONFIG_IP,
  },

  companyConfig: {
    ...COMPANY_CONFIG_IP,
  },
};
